import { render, staticRenderFns } from "./QuestionAddressStreetExtra.vue?vue&type=template&id=84850f58&scoped=true&"
import script from "./QuestionAddressStreetExtra.vue?vue&type=script&lang=js&"
export * from "./QuestionAddressStreetExtra.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAddressStreetExtra.vue?vue&type=style&index=0&id=84850f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84850f58",
  null
  
)

export default component.exports